import Vue from "vue";
import App from "./App.vue";
import AppPortal from "./AppPortal.vue";
import router from "./router";
import AutoComplete from "primevue/autocomplete";
//import Accordion from "primevue/accordion";
//import AccordionTab from "primevue/accordiontab";
import Button from "primevue/button";
import Calendar from "primevue/calendar";
import Card from "primevue/card";
import Chart from "primevue/chart";
import Checkbox from "primevue/checkbox";
import Chips from "primevue/chips";
import Column from "primevue/column";
//import DataTable from "primevue/datatable";
//import DataView from "primevue/dataview";
//import DataViewLayoutOptions from "primevue/dataviewlayoutoptions";
//import Dialog from "primevue/dialog";
import Dropdown from "primevue/dropdown";
import Editor from "primevue/editor";
import Fieldset from "primevue/fieldset";
import FileUpload from "primevue/fileupload";
//import FullCalendar from "primevue/fullcalendar";
import InputSwitch from "primevue/inputswitch";
import InputText from "primevue/inputtext";
import Listbox from "primevue/listbox";
import Menu from "primevue/menu";
import Message from "primevue/message";
import MultiSelect from "primevue/multiselect";
import OrderList from "primevue/orderlist";
import OrganizationChart from "primevue/organizationchart";
import OverlayPanel from "primevue/overlaypanel";
import Paginator from "primevue/paginator";
import Panel from "primevue/panel";
import Password from "primevue/password";
import PickList from "primevue/picklist";
import ProgressBar from "primevue/progressbar";
import ProgressSpinner from "primevue/progressspinner";
import Rating from "primevue/rating";
import RadioButton from "primevue/radiobutton";
import SelectButton from "primevue/selectbutton";
import Slider from "primevue/slider";
import Sidebar from "primevue/sidebar";
import SplitButton from "primevue/splitbutton";
import Spinner from "primevue/spinner";
import Textarea from "primevue/textarea";
import Toast from "primevue/toast";
import ToastService from "primevue/toastservice";
//import Toolbar from "primevue/toolbar";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import ToggleButton from "primevue/togglebutton";
import Tree from "primevue/tree";
import TriStateCheckbox from "primevue/tristatecheckbox";
import ValidationMessage from "primevue/validationmessage";
import VueJsonExcel from "vue-json-excel";
import VueGtag from "vue-gtag";
import VueHtmlToPaper from "vue-html-to-paper";
import QuillBetterTable from 'quill-better-table'
//import ResizeModule from "@botom/quill-resize-module";
import ImageResize from "@mgreminger/quill-image-resize-module";
import {Html5QrcodeScanner} from "html5-qrcode";
import Vidle from 'v-idle';
import CamposFormulario from './components/modulos/consultorio/CamposFormulario.vue';

Vue.use(Vidle)

const optionsHtmlToPaper = {
  name: "_blank",
  specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=no"],
  styles: [
    "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
    "https://kit-free.fontawesome.com/releases/latest/css/free.min.css"
  ]
};

Vue.use(VueHtmlToPaper, optionsHtmlToPaper);

import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
  
Vue.use(Viewer)
Vue.use(require('vue-shortkey'))

import "primevue/resources/themes/nova-light/theme.css";
import "primevue/resources/primevue.min.css";
import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
//import "@fullcalendar/core/main.min.css";
//import "@fullcalendar/daygrid/main.min.css";
//import "@fullcalendar/timegrid/main.min.css";
import "./assets/layout/layout.scss";

import store from "./store";
import AppSubmenu from "./AppSubmenu";

import axios from "axios";
import VueAxios from "vue-axios";
import VueBreadcrumbs from "vue-breadcrumbs";
import Paginate from "vuejs-paginate";
import * as moment from "moment";
import "moment/locale/pt-br";

moment.locale("pt-BR");

import VueTheMask from "vue-the-mask";
Vue.use(VueTheMask);

import Vuelidate from "vuelidate";
Vue.use(Vuelidate);

const VueUploadComponent = require("vue-upload-component");
Vue.component("file-upload", VueUploadComponent);

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

//import * as VeeValidate from 'vee-validate';
//Vue.use(VeeValidate);

import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap/dist/js/bootstrap.bundle.js";

import RelatorioGrupo from "./components/relatorios/RelatorioGrupo.vue";
import Relatorios from "./components/relatorios/Relatorios.vue";
import Relatorio from "./components/relatorios/Relatorio.vue";
import AzBreadcrumb from "./components/util/AzBreadcrumb.vue";
import AzEmptyState from "./components/util/AzEmptyState.vue";
import CadastroPadrao from "./components/cadastros/CadastroPadrao.vue";
import CadastroForm from "./components/cadastros/CadastroForm.vue";
import CadastroDetailList from "./components/cadastros/CadastroDetailList.vue";

import Chat from 'vue-beautiful-chat';
Vue.use(Chat);

import VueQRCodeComponent from 'vue-qrcode-component';
Vue.component('qr-code', VueQRCodeComponent);

import VueBarcode from 'vue-barcode';
Vue.component('barcode', VueBarcode);

import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);

Vue.directive("appsubmenu", AppSubmenu);

Vue.component('campos-formulario-2', CamposFormulario);

Vue.use(ToastService);
Vue.use(VueAxios, axios);

Vue.use(VueBreadcrumbs, {
  template:
    '<nav class="breadcrumb" v-if="$breadcrumbs.length"> ' +
    '<router-link class="breadcrumb-item" v-for="(crumb, key) in $breadcrumbs" :to="linkProp(crumb)" :key="key">{{ crumb | crumbText }}</router-link> ' +
    "</nav>"
});

Vue.config.productionTip = false;

import Toasted from 'vue-toasted';
 
Vue.use(Toasted)

//console.log('Azuremed');
//console.log(process.env.NODE_ENV);

if ( process.env.NODE_ENV == 'production' ) { 
  Vue.config.devtools = false
  Vue.config.debug = false
  Vue.config.silent = true
}

require("vue2-animate/dist/vue2-animate.min.css");

//

//

window.$ = require("jquery");
window._ = require("lodash");

//Vue.component("Accordion", Accordion);
//Vue.component("AccordionTab", AccordionTab);
Vue.component("AutoComplete", AutoComplete);
Vue.component("Button", Button);
Vue.component("Calendar", Calendar);
Vue.component("Card", Card);
Vue.component("Chart", Chart);
Vue.component("Checkbox", Checkbox);
Vue.component("Chips", Chips);
Vue.component("Column", Column);
//Vue.component("DataTable", DataTable);
//Vue.component("DataView", DataView);
//Vue.component("DataViewLayoutOptions", DataViewLayoutOptions);
//Vue.component("Dialog", Dialog);
Vue.component("Dropdown", Dropdown);
Vue.component("Editor", Editor);
Vue.component("Fieldset", Fieldset);
Vue.component("FileUpload", FileUpload);
//Vue.component("FullCalendar", FullCalendar);
Vue.component("InputSwitch", InputSwitch);
Vue.component("InputText", InputText);
Vue.component("Listbox", Listbox);
Vue.component("Menu", Menu);
Vue.component("Message", Message);
Vue.component("MultiSelect", MultiSelect);
Vue.component("OrderList", OrderList);
Vue.component("OrganizationChart", OrganizationChart);
Vue.component("OverlayPanel", OverlayPanel);
Vue.component("Paginator", Paginator);
Vue.component("Panel", Panel);
Vue.component("Password", Password);
Vue.component("ProgressBar", ProgressBar);
Vue.component("ProgressSpinner", ProgressSpinner);
Vue.component("PickList", PickList);
Vue.component("RadioButton", RadioButton);
Vue.component("Rating", Rating);
Vue.component("SelectButton", SelectButton);
Vue.component("Slider", Slider);
Vue.component("Sidebar", Sidebar);
Vue.component("Spinner", Spinner);
Vue.component("SplitButton", SplitButton);
Vue.component("TabView", TabView);
Vue.component("TabPanel", TabPanel);
Vue.component("Textarea", Textarea);
Vue.component("Toast", Toast);
// Vue.component("Toolbar", Toolbar);
Vue.component("ToggleButton", ToggleButton);
Vue.component("Tree", Tree);
Vue.component("TriStateCheckbox", TriStateCheckbox);
Vue.component("ValidationMessage", ValidationMessage);
Vue.component("paginate", Paginate);
Vue.component("relatorio-grupo", RelatorioGrupo);
Vue.component("relatorios", Relatorios);
Vue.component("relatorio", Relatorio);
Vue.component("az-breadcrumb", AzBreadcrumb);
Vue.component("az-empty-state", AzEmptyState);
Vue.component("cadastro-padrao", CadastroPadrao);
Vue.component("cadastro-form", CadastroForm);
Vue.component("cadastro-detail-list", CadastroDetailList);
Vue.component('JsonExcel', VueJsonExcel);
Vue.component('DatePicker', DatePicker);

Vue.component('qrcode-scanner', {
  data() { 
    return { 
      html5QrcodeScanner: null, 
    }
  },

  props: {
    qrbox: Number,
    fps: Number,
  },

  render: function (createElement) {
    let item = createElement(
      'div'
    );

    item.id = 'qr-code-full-region';

    return item;
  },

  // template: `<div id="qr-code-full-region"></div>`,

  methods: { 
    onScanSuccess(qrCodeMessage) {
      console.log(qrCodeMessage);
      this.$emit('result', { text: qrCodeMessage });
    }
  },

  beforeUnmount: function () {
    if ( this.html5QrcodeScanner.html5Qrcode.isScanning ) {
      this.html5QrcodeScanner.html5Qrcode.stop().then((ignore) => {
        // QR Code scanning is stopped.
        console.log(ignore);
      }).catch((err) => {
        // Stop failed, handle it.
        console.log(err);
      });
    }
  },

  mounted: function () {
    var config = { fps: this.fps ? this.fps : 10 };
    if (this.qrbox) {
      config['qrbox'] = this.qrbox;
    }

    /*
    function onScanSuccess(qrCodeMessage) {
      console.log(qrCodeMessage);
      this.$emit('result', qrCodeMessage);
    }
    */
    
    this.html5QrcodeScanner = new Html5QrcodeScanner(
      "qr-code-full-region", config
    );

    console.log(this.html5QrcodeScanner);

    this.html5QrcodeScanner.render(this.onScanSuccess);
    console.log('State', this.html5QrcodeScanner.html5Qrcode.getState());
  }
});

Quill.register({
  'modules/better-table': QuillBetterTable
}, true);

/*
Quill.register({
  'modules/resize': ResizeModule
}, true);
*/

Quill.register({
    'modules/imageResize': ImageResize
}, true);

// QUILL ACEITAR REDIMENSIONAR IMAGEM

/*
const Image = Quill.import('formats/image');

class CustomImage extends Image {
    static formats(domNode) {
        const formats = super.formats ? super.formats(domNode) || {} : {};

        const width = domNode.style.width || domNode.getAttribute('width');

        if (width) {
            formats.width = width;
        }

        return formats;
    }

    format(name, value) {
        if (name === 'width') {
            if (value) {
                this.domNode.style.width = value;
                this.domNode.setAttribute('width', value);
            } else {
                this.domNode.style.width = '';
                this.domNode.removeAttribute('width');
            }

            return;
        }

        super.format(name, value);
    }

    static value(domNode) {
        return domNode.getAttribute('src');
    }
}

CustomImage.blotName = 'image';
CustomImage.tagName = 'img';

Quill.register(CustomImage, true);
*/

//

// config();

const host = window.location.host;
const parts = host.split(".");
//const domainLength = 3;
let teste;
let portal = false;

if (parts[0] == "az2-dev") {
  teste = "gandra2";
} else if (parts[0] == "app" || parts[0] == 'd1e061miudfxst') {
  teste = "homologacao";
} else if (parts[0] == "az2-teste" || parts[0] == "localhost:8080") {
  teste = "base";
} else {
  teste = parts[0];
  if (parts[0].substr(0,7) == "portal-") {
    portal = true;
    teste = parts[0].substr(7);
  }
}

//console.log(teste);

const domain = teste;
window.redir = teste;

if ( process.env.VUE_APP_GTAG ) { 
  Vue.use(VueGtag, {
    config: { id: process.env.VUE_APP_GTAG },
    appName: portal ? 'portal-' + domain : domain,
    globalDimensions: [
      { dimension: 1, value: 'ABC' },
      { dimension: 2, value: 'DEF' }
    ],
  }, router);
}

axios.interceptors.response.use(
  function(response) {
    if (typeof response.data == "object") {
      window._.each(response.data, function(item) {
        if (item && item.status && ( item.status == 290 || item.status == 291 ) ) {
          window.app.$toast.add({
            severity: item.status == 291 ? 'warn' : 'success',
            summary: "Atenção",
            detail: item.data.msg,
            life: item.data.tempo ? item.data.tempo : 5000
          });
        } else if (item && item.status && item.status != 200 && !isNaN(item.status) ) {
          let error = {
            response: {
              status: item.status,
              data: {
                errors: item.error
                  ? item.error
                  : typeof item.data.msg == "string"
                  ? [item.data.msg]
                  : item.data.msg,
                tempo: item.data ? item.data.tempo : 5000, 
              },
            }
          };
          window.app.handleError(error);
        }
      });
    }
    return response;
  },
  function(error) {
    window.app.handleError(error);
    return error;
  }
);

const tratarErrosEspeciais = erro => {
  if (erro == "Token has expired") {
    window.app.$store.commit("setUser", null);
  } else if (erro && erro.substr(0, 14) == "Acesso negado.") {
    setTimeout(() => {
        window.app.$toast.add({
          severity: "error",
          summary: "Atenção!!",
          detail: erro,
          life: 10000
        });

        window.$('.modal').modal('hide');
        window.app.$router.push({ name: "dashboard" });
    }, 3000);
  }
};

Vue.prototype.handleError = error => {

  if (error && error.response) {

    if (error.response.status == 419) {
      window.app.$store.commit("setUser", null);
    } else if (error.response.status == 428) {
      let token = window._.get(error.response.data.message.split('|'), '1');

      window.app.$router.push({ 
        path: '/redefinirsenha/' + token + '?r=1'
      });
    }

    let lista = [];

    lista = window._.flattenDeep(window._.toArray(error.response.data.errors));

    if (!lista.length) {
      if (error.response.data.message) lista[0] = error.response.data.message;
      else if (typeof error.response.data == "string")
        lista[0] = error.response.data;
    }

    window._.forEach(lista, function(value) {
      window.app.$toast.add({
        severity: "error",
        summary: "Atenção",
        detail: value,
        life: ( error.response.data && error.response.data.tempo ) ? error.response.data.tempo : 5000
      });

      tratarErrosEspeciais(value);
    });
  } else if (error && error.message) {

    let msg = ( error.message == 'Network Error' ? 'Backend Offline' : error.message );

    if ( msg != '#BC#' ) { 

      window.app.$toast.add({
        severity: "error",
        summary: "Atenção",
        detail: msg,
        life: 5000
      });

    }

    tratarErrosEspeciais(error.message);

  } else if (error) {

    window.app.$toast.add({
      severity: "error",
      summary: "Atenção",
      detail: error,
      life: 5000
    });

    tratarErrosEspeciais(error);

  } else {

    console.log("Erro Else...");

  }
};

//

Vue.prototype.loadOptions = (service, id, parms) => {
  let name = id ? id : service;

  if (window.app.$store.state.options[name]) {
    //return window.app.$store.state.options[service];

    return new Promise(function(resolve) {
      //console.log('Resolve:', window.app.$store.state.options[service]);
      resolve(window.app.$store.state.options[name]);
    });
  }

  let query = {
    q: [
      {
        name: service,
        id: "lista",
        parms: parms
      }
    ]
  };

  return Vue.axios.post("/aql?la=" + service, query).then(res => {
    let options = { name: name, list: res.data.lista.data };
    window.app.$store.commit("setOptions", options);
    return res.data.lista.data;
  });
};

// Quill
import * as Quill from "quill";

let Inline = Quill.import('blots/inline');

/*

class CampoIdBlot extends Inline {
  
  static create(value) {
    const node = super.create();
    node.setAttribute('id', value.id);
    return node;
  }

  static formats(domNode) {
    return domNode;
  }

  static value(domNode) {
    return {
      id: domNode.dataset.id,
      url: domNode.dataset.url,
      html: domNode.dataset.html,
      type: domNode.dataset.type,
    };
  }
}

CampoIdBlot.blotName = 'campo';
CampoIdBlot.tagName = 'code';
CampoIdBlot.className = 'ql-campo';

console.log(CampoIdBlot);

*/

function CampoIdBlott() {
  return Reflect.construct(Inline, arguments, CampoIdBlott);
}
Reflect.setPrototypeOf(CampoIdBlott.prototype, Inline.prototype);
Reflect.setPrototypeOf(CampoIdBlott, Inline);

CampoIdBlott.create = function (value) {
  let node = document.createElement('code');
  node.classList.add('ql-campo');
  node.setAttribute('id', value.id);

  return node;
}

CampoIdBlott.formats = function (domNode) {
  return domNode;
}

CampoIdBlott.value = function (domNode) {
  return {
    id: domNode.dataset.id,
    url: domNode.dataset.url,
    html: domNode.dataset.html,
    type: domNode.dataset.type,
  };
}

CampoIdBlott.blotName = 'campo';
CampoIdBlott.tagName = 'code';
CampoIdBlott.className = 'ql-campo';

Quill.register(CampoIdBlott);

//
let Size = Quill.import('attributors/style/size');
//Size.whitelist = ['small', 'large', 'huge', '9px', '10px', '11px', '12px', '13px', '14px', '15px', '16px', '17px', '18px', '24px', '32px'];
Size.whitelist = ['9px', '10px', '11px', '12px', '13px', '14px', '15px', '16px', '17px', '18px', '24px', '32px'];
Quill.register(Size, true);
//

// Notificações 

//const client = require('pusher-js');
import Pusher from 'pusher-js';
if ( !Pusher ) { 
  console.log(Pusher);
}

import Echo from "laravel-echo"

//console.log('BASE URL', process.env.VUE_APP_BASEURL);

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: process.env.VUE_APP_PUSHER_APP_KEY,
    cluster: process.env.VUE_APP_PUSHER_APP_CLUSTER,
    forceTLS: true,
    encrypted: true,
    authEndpoint: process.env.VUE_APP_BASEURL.slice(0,-5) + '/broadcasting/auth',
    auth: {
      headers: {
        Authorization: null
      }
    },
});

// Helpers

import util from "./util";
import utilform from "./utilform";

const plugin = {
  install() {
    Vue.prototype.$util = util;
    Vue.prototype.$utilform = utilform;
  }
};

Vue.use(plugin);

import JsonCSV from 'vue-json-csv'

Vue.component('downloadCsv', JsonCSV)

//Vue.axios.defaults.headers.post['X-DOMAIN'] = domain;
//Vue.axios.defaults.baseURL = 'http://3.88.40.211/api/';
//'http://localhost:8010/api/';

Vue.axios.defaults.headers.post["X-DOMAIN"] = domain;
Vue.axios.defaults.headers.post["X-PORTAL"] = portal ? 1 : 0;

Vue.axios.defaults.headers.get["X-DOMAIN"] = domain;
Vue.axios.defaults.headers.get["X-PORTAL"] = portal ? 1 : 0;

// Vue.axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';

if ( process.env.NODE_ENV == 'production' ) { 
  //Vue.axios.defaults.headers.post["Strict-Transport-Security"] = 'max-age=63072000; includeSubDomains; preload';
  //Vue.axios.defaults.headers.get["Strict-Transport-Security"] = 'max-age=63072000; includeSubDomains; preload';
}

Vue.axios.defaults.baseURL = process.env.VUE_APP_BASEURL;
store.commit("setDominio", domain);

//console.log(Vue.axios.defaults.baseURL);

window.app = new Vue({
  router,
  store,
  util,
  render: portal ? h => h(AppPortal) : h => h(App),
  methods: {
    perfil(paciente) {
      this.$root.$children[0].$refs.perfil.abrir(paciente);
    },
    perfil_temp(cadastro_temporario) { 
      this.$root.$children[0].$refs.perfil.abrir_temporario(cadastro_temporario);
    },
    editar_marcacao(id, callback = null, parms = null) { 
      this.$root.$children[0].$refs.editmrc.abrir(id, callback, parms);
    },
    remarcar(id, outros_parms = null) { 
      this.$root.$children[0].$refs.remarc_combo.remarcar(id, false, outros_parms);
    },
    solicitar_estoque(tipo = 'S', parms = null) { 
        this.$root.$children[0].$refs.apptop.solic_estoque(tipo, parms);
    }
  }
}).$mount("#app");
